import React from 'react';
import {useUpdateClientProspectScoreSettingCustomizeItemNumberMutation} from 'api';
import {CustomizeItemContext} from '../../CustomizeItemContext';

export default function Input({priority}: {priority: number}) {
  const customizeItem = React.useContext(CustomizeItemContext);
  const [update] = useUpdateClientProspectScoreSettingCustomizeItemNumberMutation(
    {},
  );
  const selected =
    customizeItem?.clientProspectScoreSettingCustomizeItemNumbers?.find(
      (number) => number.priority === String(priority),
    ) ?? null;

  const [minValue, setMinValue] = React.useState(selected?.minValue?.toString() ?? '');
  const [maxValue, setMaxValue] = React.useState(selected?.maxValue?.toString() ?? '');

  const handleUpdate = () => {
    const min = minValue === '' ? null : Number(minValue);
    const max = maxValue === '' ? null : Number(maxValue);
    
    if (min !== null && max !== null && min > max) {
      alert('最小値は最大値以下である必要があります');
      return;
    }

    update({
      variables: {
        input: {
          priority,
          minValue: min,
          maxValue: max,
          prospectScoreSettingCustomizeItemId: customizeItem?.id,
        },
      },
    });
  };

  return (
    <div className="flex items-center gap-2">
      <div className="text-sm font-bold w-16 text-center flex items-center">
        <span>優先度 {priority}</span>
      </div>
      <div className="flex items-center gap-2">
        <input
          type="number"
          className="border border-c-border rounded text-sm h-8 px-3 py-2 text-c-dark-gray bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
          style={{width: '100px', height: '32px'}}
          placeholder=""
          value={minValue}
          onChange={(e) => setMinValue(e.target.value)}
          onBlur={handleUpdate}
        />
        <span className="text-sm text-c-gray flex items-center justify-center" style={{width: '12px', height: '32px'}}>
          〜
        </span>
        <input
          type="number"
          className="border border-c-border rounded text-sm h-8 px-3 py-2 text-c-dark-gray bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
          style={{width: '100px', height: '32px'}}
          placeholder=""
          value={maxValue}
          onChange={(e) => setMaxValue(e.target.value)}
          onBlur={handleUpdate}
        />
      </div>
    </div>
  );
}